import {
    ElectionDefinition,
    isElectionFeatureEnabled,
    TogglesReduxState,
} from '@news-mono/web-common'
import { layout } from '../../App.routing'
import { metrics } from '@news-mono/component-library'

/** This controls the Head to Head widget and Election Navigation segments, controlled separately from the Election Collection */
export const federalElectionHeadToHeadAndNavigationSegment = (
    electionDefinition: ElectionDefinition,
    toggles: TogglesReduxState,
) => {
    const { logo, electionId } = electionDefinition

    const isSegmentEnabled = isElectionFeatureEnabled(
        toggles,
        electionId,
        'election-homepage-head-to-head-nav-top',
    )
    const isHeadToHeadCountdownEnabled = isElectionFeatureEnabled(
        toggles,
        electionId,
        'election-head-to-head-countdown',
    )

    return layout.composition({
        type: 'box',
        props: {
            hideBottomGap: true,
            containerWidth: metrics.thenightly.siteMetrics.mainContentWidth,
            fullWidth: true,
            flex: {
                default: {
                    flexDirection: 'column',
                },
                sm: {},
            },
        },
        contentAreas: {
            main: [
                ...(isSegmentEnabled
                    ? [
                          layout.component({
                              type: 'election-head-to-head-seat-count-widget',
                              props: {
                                  electionDefinition,
                                  countdownEnabled:
                                      isHeadToHeadCountdownEnabled,
                              },
                          }),
                          layout.component({
                              type: 'election-navigation',
                              props: {
                                  electionDefinition,
                                  electionLogo: logo,
                              },
                          }),
                      ]
                    : []),
            ],
        },
    })
}
